import _ from "lodash";
import axios from "axios";
import jwtDecode from "jwt-decode";

import { Dlog } from "./Dlog";

let env = require("./../env.js");

const API_ENDPOINT = env.REACT_APP_API_ENDPOINT;

export const get = async (url, params) => {
  try {
    // Dlog("DEBUG: GET api.js", accessToken);

    const accessToken = await checkAndFetchAuthToken(url);

    const res = await axios({
      method: "GET",
      url: API_ENDPOINT + url,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params,
      withCredentials: isLogoutEndpoint(url) // Need to pass cookie back for logging out
    });

    Dlog("DEBUG", res);

    return res;
  } catch (err) {
    console.error(err);

    const response = _.get(err, "response");
    if (response) {
      return response;
    }

    return { status: 400 };
  }
};

export const post = async (
  url,
  data,
  type = "application/x-www-form-urlencoded"
) => {
  try {
    // Dlog("DEBUG: POST api.js", data, accessToken);

    const accessToken = await checkAndFetchAuthToken(url);

    const res = await axios({
      method: "POST",
      url: API_ENDPOINT + url,
      data,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": type
      },
      withCredentials: isAuthEndpoint(url)
    });

    Dlog("DEBUG", res);

    return res;
  } catch (err) {
    console.error(err);

    const response = _.get(err, "response");
    if (response) {
      return response;
    }

    return { status: 400 };
  }
};

export const simpleget = async (url, params) => {
  try {
    Dlog("DEBUG: simple GET api.js");

    const res = await axios({
      method: "GET",
      url: API_ENDPOINT + url,
      params
    });

    Dlog("DEBUG", res);

    return res;
  } catch (err) {
    console.error(err);

    const response = _.get(err, "response");
    if (response) {
      return response;
    }

    return { status: 400 };
  }
};

export const simplepost = async (
  url,
  data,
  type = "application/x-www-form-urlencoded"
) => {
  try {
    Dlog("DEBUG: simple POST api.js", data);

    const res = await axios({
      method: "POST",
      url: API_ENDPOINT + url,
      data,
      headers: {
        "Content-Type": type
      }
    });

    Dlog("DEBUG", res);

    return res;
  } catch (err) {
    console.error(err);

    const response = _.get(err, "response");
    if (response) {
      return response;
    }

    return { status: 400 };
  }
};

export const fileuploadpost = async (url, data) => {
  try {
    const accessToken = await checkAndFetchAuthToken(url);

    const res = await axios({
      method: "POST",
      url: API_ENDPOINT + url,
      data,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      withCredentials: isAuthEndpoint(url)
    });

    Dlog("DEBUG", res);

    return res;
  } catch (err) {
    console.error(err);

    const response = _.get(err, "response");
    if (response) {
      return response;
    }

    return { status: 400 };
  }
};

export const getCheckedAuthToken = async () => {
  return await checkAndFetchAuthToken();
};

function isAuthEndpoint(url) {
  console.log("isAuthEndpoint url", url);
  return (
    url == "/login" ||
    url == "/register" ||
    url == "/forgetpassword" ||
    url == "/forgetpasswordsent" ||
    url == "/resetpassword"
  );
}

function isLogoutEndpoint(url) {
  return url == "/logout";
}

function isTokenExpired(token) {
  const decodedToken = jwtDecode(token);
  const expirationDate = new Date(decodedToken.exp * 1000);

  return new Date() > expirationDate;
}

//If used by internal, include url for AuthEndpoints checks
//if not, its probably used by socket.io
async function checkAndFetchAuthToken(url = null) {
  let accessToken = localStorage.getItem("accessToken");

  Dlog("DEBUG: GET api.js", accessToken);

  if (url != null) {
    if (!isAuthEndpoint(url) && (!accessToken || isTokenExpired(accessToken))) {
      accessToken = await getNewToken();
    }
  } else {
    if (!accessToken || isTokenExpired(accessToken)) {
      accessToken = await getNewToken();
    }
  }

  return accessToken;
}

async function getNewToken() {
  const authenticationRes = await axios({
    method: "get",
    url: API_ENDPOINT + "/refreshAuth",
    withCredentials: true
  });

  if (authenticationRes.status != 200) {
    throw new Error("An authentication error occurred");
  }

  const accessToken = _.get(authenticationRes, "data.accessToken");
  if (!accessToken) {
    throw new Error("An authentication error occurred");
  }

  localStorage.setItem("accessToken", accessToken);
  return localStorage.getItem("accessToken");
}
